import React from 'react';
import { Link } from 'react-router-dom';
import {
    FaFacebook,
    FaInstagram,
    FaYoutube,
    FaTwitter,
    FaLinkedin
} from 'react-icons/fa';
import './Footer.css';

function Footer() {
    return (
        <div className='footer-container'>
            <section className='footer-wrap'>
                <Link to='/' className='footer-logo'>
                    <img src='/images/banner.png' alt='Home Banner' />
                </Link>
                <small className='website-rights'>Copyright © {(new Date().getFullYear())} by KAI CHENG. All Rights Reserved. </small>
                <div className='social-icons'>
                    <Link className='social-icon-link' to='//www.facebook.com/kaichengster/' target='_blank' aria-label='Facebook'>
                        <FaFacebook />
                    </Link>
                    <Link className='social-icon-link' to='//www.instagram.com/kaichengster/' target='_blank' aria-label='Instagram'>
                        <FaInstagram />
                    </Link>
                    <Link className='social-icon-link' to='//www.youtube.com/kaichengster/' target='_blank' aria-label='Youtube'>
                        <FaYoutube />
                    </Link>
                    <Link className='social-icon-link' to='//www.twitter.com/kaichengster/' target='_blank' aria-label='Twitter'>
                        <FaTwitter />
                    </Link>
                    <Link className='social-icon-link' to='//www.linkedin.com/in/kaichengster/' target='_blank' aria-label='LinkedIn'>
                        <FaLinkedin />
                    </Link>
                </div>
            </section>
        </div>
    );
}

export default Footer;
